module.exports = __webpack_public_path__ + "static/media/cert_133.6cb8aeca.jpg";